import { DatePicker, DatePickerProps } from '@arco-design/web-react';

import React from 'react';

export function SelectDate({ value, onChange, ...rest }: DatePickerProps) {
  return <DatePicker style={{ width: '100%' }} value={value} onChange={onChange} {...rest} />;
}
